/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Vekn_PushInputs */



/**
* | output |
* | --- |
* | "When are events pushed to VEKN?" |
*
* @param {Og_Faq_Q_Vekn_PushInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_vekn_push = /** @type {((inputs?: Og_Faq_Q_Vekn_PushInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Vekn_PushInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quand les événements sont-ils publiés sur VEKN ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cuándo se envían los eventos a VEKN?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Quando os eventos são enviados para a VEKN?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quando vengono inviati gli eventi al VEKN?")
	return /** @type {LocalizedString} */ ("When are events pushed to VEKN?")
});